import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { inject } from '@vercel/analytics';
import { App } from './App';
import './styles/globals.css';

inject();

Sentry.init({
  dsn: 'https://57372c1a63f8a1c21650855444482b51@o4511739695988736.ingest.de.sentry.io/4511739711914064',
  environment: import.meta.env.MODE,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
